import { Color } from '@persona-id/design-tokens';

const PersonaIcon = ({ active }: { active: boolean }) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.2485 14.2997C14.5763 14.2997 16.4635 12.4125 16.4635 10.0846C16.4635 7.75676 14.5763 5.86963 12.2485 5.86963C9.92058 5.86963 8.03345 7.75676 8.03345 10.0846V18.1513H10.2136V14.2997H12.2485ZM14.2833 10.0846C14.2833 11.2084 13.3723 12.1194 12.2485 12.1194H10.2137V10.0846C10.2137 8.96078 11.1247 8.04975 12.2485 8.04975C13.3723 8.04975 14.2833 8.96078 14.2833 10.0846Z'
        fill={active ? Color.CorePurple800 : Color.CorePurple600}
      />
      <circle
        cx='12'
        cy='12'
        r='11'
        stroke={active ? Color.CorePurple800 : Color.CorePurple600}
        strokeWidth='2'
      />
    </svg>
  );
};

export default PersonaIcon;
